import { useQuery } from "@tanstack/react-query";
import { getWallet } from "../services/wallet";

export function useWallet(options = {}) {

    const outletUid = localStorage.getItem(

        "selectedOutletUid"

    );

    return useQuery({

        queryKey: [

            "wallet",

            outletUid,

        ],

        queryFn: () =>

            getWallet(

                outletUid

            ),

        enabled: !!outletUid,

        staleTime: 1000 * 60 * 5,

        ...options,

    });

}